import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { ProductIcon } from "@/components/bakery/Art";
import { CATEGORY_ORDER, groupBy } from "@/lib/format";
import { cn } from "@/lib/utils";

export default function ProductPicker({ products, value, onChange, filter, testid = "product-picker", placeholder = "Pilih produk", showStock }) {
  const [open, setOpen] = useState(false);
  const list = (products || []).filter((p) => p.active && (!filter || filter(p)));
  const groups = groupBy(list, (p) => p.category);
  const selected = (products || []).find((p) => p.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="press flex h-12 w-full items-center gap-2 rounded-md border border-zinc-300 bg-white px-3 text-left text-sm hover:border-ink">
          {selected ? <ProductIcon category={selected.category} bundle={selected.is_bundle} className="h-5 w-5 shrink-0" /> : null}
          <span className={cn("flex-1 truncate", !selected && "text-zinc-400")}>{selected ? selected.name : placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 text-zinc-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[280px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Cari produk..." data-testid={`${testid}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>Produk tidak ditemukan.</CommandEmpty>
            {CATEGORY_ORDER.filter((c) => groups[c]).map((c) => (
              <CommandGroup key={c} heading={c}>
                {groups[c].map((p) => (
                  <CommandItem key={p.id} value={`${p.code} ${p.name}`} onSelect={() => { onChange(p.id); setOpen(false); }}
                    data-testid={`${testid}-option-${p.code}`} className="py-2.5">
                    <ProductIcon category={p.category} bundle={p.is_bundle} className="h-4 w-4" />
                    <span className="flex-1 truncate">{p.name}</span>
                    {showStock && !p.is_bundle && <span className={cn("num text-xs", p.stock <= 0 ? "text-brand" : "text-zinc-500")}>{p.stock}</span>}
                    {value === p.id && <Check className="h-4 w-4" />}
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
